
import LoginContainer from '../containers/LoginContainer/LoginContainer';

const Login = () => <LoginContainer />;

export default Login;
